/**
 * The timezone the admin panel renders dates in. Pure, so the server entry can
 * read the cookie without pulling a React component into the server bundle.
 */
export const TIME_ZONE_COOKIE = "tz";

/** An IANA zone this runtime knows, or UTC. Cookies are user input. */
export function safeZone(value: string | undefined | null): string {
	if (!value) {
		return "UTC";
	}
	try {
		new Intl.DateTimeFormat("en-US", { timeZone: value });
		return value;
	} catch {
		return "UTC";
	}
}

/** Beirut from "Asia/Beirut": the city is what a person recognises. */
export function zoneLabel(timeZone: string): string {
	const city = timeZone.split("/").pop()?.replaceAll("_", " ");
	return city && city !== timeZone ? city : timeZone;
}
